"use strict";

exports.__esModule = true;
exports.default = useUppy;
var _react = require("react");
var _core = require("@uppy/core");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * @deprecated Initialize Uppy outside of the component.
 */
function useUppy(factory) {
  if (typeof factory !== 'function') {
    throw new TypeError('useUppy: expected a function that returns a new Uppy instance');
  }
  var uppy = (0, _react.useRef)(undefined);
  if (uppy.current === undefined) {
    uppy.current = factory();
    if (!(uppy.current instanceof _core.Uppy)) {
      throw new TypeError("useUppy: factory function must return an Uppy instance, got ".concat(_typeof(uppy.current)));
    }
  }
  (0, _react.useEffect)(function () {
    return function () {
      var _uppy$current;
      (_uppy$current = uppy.current) == null || _uppy$current.close({
        reason: 'unmount'
      });
      uppy.current = undefined;
    };
  }, [uppy]);
  return uppy.current;
}